/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_business_profile_what_company_does = /** @type {(inputs: {}) => string} */ () => {
	return `¿Qué hace tu empresa?`
};

const en_onboarding_business_profile_what_company_does = /** @type {(inputs: {}) => string} */ () => {
	return `What does your company do?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_business_profile_what_company_does = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_business_profile_what_company_does(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_business_profile_what_company_does", locale)
	if (locale === "es") return es_onboarding_business_profile_what_company_does(inputs)
	return en_onboarding_business_profile_what_company_does(inputs)
};
export { onboarding_business_profile_what_company_does as "onboarding.business_profile.what_company_does" }